import styled from '@emotion/styled';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Theme } from '../../theme';

export type NavLinkItem = {
  /**
   * Text for the nav link
   */
  text: React.ReactNode;
  /**
   * Path of the link
   */
  href: string;
};

const StyledNavLink = styled(RouterNavLink)((props: { theme: Theme }) => ({
  // Box Model
  background: props.theme.colors.navbar,
  padding: props.theme.space[4],
  display: 'flex',
  alignItems: 'center',
  // Link Reset
  textDecoration: 'none',
  // Text style
  transition: 'all .3s ease',
  color: props.theme.colors.onNavbar,
  textTransform: 'uppercase',
  fontSize: props.theme.fontSizes[2],
  fontWeight: props.theme.fontWeights.body,
  lineHeight: props.theme.fontSizes[2] + 'px',
  borderBottom: '2px solid',
  borderColor: props.theme.colors.navbar,

  '&:hover': {
    color: props.theme.colors.onNavbarHover,
    borderColor: props.theme.colors.onNavbarHover,
    cursor: 'pointer',
  },

  '&.active': {
    color: props.theme.colors.onNavbarHover,
    borderColor: props.theme.colors.onNavbarHover,
  },
}));

export default StyledNavLink;
